module.exports = __webpack_public_path__ + "img/DK.510f0e8b.svg";